import Lookup from './lookup.js';

export default class LevelThree extends Lookup
{
    
}
